/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Download File Icon component.
 */
export const SystemDownloadFileIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_22725)'>
        <path d='M8.39014 11.4297L11.6801 15.0197L14.8401 11.4297' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M11.6799 15.01L11.6499 4' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M20.23 13.9395V19.1695H3V13.9395' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_14304_22725'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SystemDownloadFileIcon;
